import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectFortuneTellerEventPackageDetails, selectFortuneTellerEventRemainingTime, selectIsFortuneTellerEventRunning, selectIsPlayerQualifiedForFortuneTellerEvent, } from "../../../selectors/selectFortuneTellerEventInfo";
import { utilButton } from "../../../utils/utilButton";
import { TimerCountdown } from "../../generic/timer/TimerCountdown";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
var _HudButtonFortuneTellerEvent = function (_a) {
    var onClick = _a.onClick, fortuneTellerEventRemainingTime = _a.fortuneTellerEventRemainingTime, shouldRender = _a.shouldRender;
    if (!shouldRender) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: IdStyles.TraderBadge + "  hud-button__offers hud-button__fortune-teller-event", onClick: function () { return utilButton.onClickWithSound(onClick); } },
        React.createElement(TimerCountdown, { remainingTime: fortuneTellerEventRemainingTime, className: IdStyles.TextBoldPrimary + " hud-button__purchase-points-event-text" })));
};
var mapState = function (state) { return ({
    fortuneTellerEventRemainingTime: selectFortuneTellerEventRemainingTime(state),
    shouldRender: selectIsFortuneTellerEventRunning(state) &&
        selectIsPlayerQualifiedForFortuneTellerEvent(state) &&
        selectFortuneTellerEventPackageDetails(state) != undefined,
}); };
var mapDispatch = function (dispatch) { return ({
    onClick: function () { return dispatch(actionModalOpen(IdModal.FortuneTellerEvent)); },
}); };
export var HudButtonFortuneTellerEvent = connect(mapState, mapDispatch)(_HudButtonFortuneTellerEvent);



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/components/HudButtonFortuneTellerEvent.tsx
// module id = 2294
// module chunks = 3